// ABOUTME: Verification required component for Oráculo dos 12 Raios
// ABOUTME: Displays when user is logged in but email not verified, with resend functionality
// TD3-123: Email verification enforcement - polite message with resend option

import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './VerificationRequired.css';

const VerificationRequired = () => {
  const { user, logout, resendVerification } = useAuth();
  const [isResending, setIsResending] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [cooldown, setCooldown] = useState(0);

  // Cooldown timer effect
  useEffect(() => {
    if (cooldown > 0) {
      const timer = setTimeout(() => {
        setCooldown(cooldown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldown]);

  // Clear messages after 5 seconds
  useEffect(() => {
    if (message.text) {
      const timer = setTimeout(() => {
        setMessage({ type: '', text: '' });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const handleResendVerification = async () => {
    if (cooldown > 0 || !user?.email) return;

    try {
      setIsResending(true);
      setMessage({ type: '', text: '' });

      const result = await resendVerification(user.email);

      if (result.success) {
        setMessage({ type: 'success', text: 'Email de verificação enviado com sucesso!' });
        setCooldown(60); // 60-second cooldown
      } else {
        setMessage({ type: 'error', text: result.error || 'Erro ao enviar email. Tente novamente.' });
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Erro ao enviar email. Tente novamente.' });
    } finally {
      setIsResending(false);
    }
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="verification-required-container">
      <div className="verification-required-card">
        <div className="verification-icon">
          <span className="icon-email">📧</span>
        </div>

        <h1>Verificação de Email Necessária</h1>

        <p className="verification-description">
          Por favor, verifique seu email para acessar o Oráculo dos 12 Raios
        </p>

        <div className="user-email">
          <span className="email-label">Email enviado para:</span>
          <span className="email-value">{user?.email}</span>
        </div>

        {/* Message Display */}
        {message.text && (
          <div className={`verification-message ${message.type}`}>
            {message.text}
          </div>
        )}

        <div className="verification-instructions">
          <p>✨ Verifique sua caixa de entrada e spam</p>
          <p>🔮 Clique no link de verificação no email</p>
          <p>⏰ <strong>O link expira em 2 horas</strong></p>
          <p>💫 Retorne ao Oracle para começar sua jornada</p>
        </div>

        <div className="verification-actions">
          <button
            onClick={handleResendVerification}
            disabled={isResending || cooldown > 0}
            className="resend-btn primary-cta"
          >
            {isResending ? (
              'Enviando...'
            ) : cooldown > 0 ? (
              `Aguarde ${cooldown}s para reenviar`
            ) : (
              'Reenviar Email de Verificação'
            )}
          </button>

          <button
            onClick={handleLogout}
            className="logout-btn secondary-cta"
          >
            Sair
          </button>
        </div>

        <div className="verification-help">
          <p>Não recebeu o email? Verifique sua pasta de spam ou solicite um novo.</p>
        </div>
      </div>
    </div>
  );
};

export default VerificationRequired;
